import Card from '../../components/common/Card';

/**
 * About - Hakkımızda sayfası
 * 
 * Sections:
 * 1. Hero - Page title and introduction
 * 2. Mission - Misyonumuz
 * 3. Vision - Vizyonumuz
 * 4. Values - Core values (4 cards)
 * 
 * Design: Clean, professional, inspiring
 */
const About = () => {
  // Core values data
  const values = [
    {
      icon: '💡',
      title: 'İnovasyon',
      description:
        'Teknoloji ve hukuki süreçleri bir araya getirerek, sektörde yenilikçi çözümler sunuyoruz.',
    },
    {
      icon: '🤝',
      title: 'Güven',
      description:
        'Müşterilerimizin verilerini en üst düzeyde koruyarak, güvenilir bir platform sunuyoruz.',
    },
    {
      icon: '⭐',
      title: 'Kalite',
      description:
        'Tüm şablonlarımız hukuki danışmanlar tarafından hazırlanmış ve güncel mevzuata uygundur.',
    },
    {
      icon: '❤️',
      title: 'Müşteri Odaklılık',
      description:
        'Kullanıcı deneyimini önceliğimiz yaparak, her adımda müşterilerimizin yanındayız.',
    },
  ];

  return (
    <div className="bg-white">
      {/* Section 1: Hero */}
      <section className="bg-gray-50 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Hakkımızda
            </h1>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              contractcode olarak, hukuki belge oluşturma süreçlerini
              dijitalleştirerek, bireylerin ve şirketlerin iş yükünü
              hafifletiyoruz. Teknoloji ve hukuku bir araya getirerek, herkes
              için erişilebilir, hızlı ve güvenilir çözümler sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Section 2: Mission */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Misyonumuz
              </h2>
              <div className="w-20 h-1 bg-primary-500 mx-auto mb-8"></div>
            </div>
            <div className="bg-gray-50 rounded-lg p-8 md:p-12">
              <p className="text-lg text-gray-700 leading-relaxed text-center">
                Hukuki belge oluşturma süreçlerini sadeleştirerek, bireylerin ve
                şirketlerin zaman ve maliyet tasarrufu yapmasını sağlamak.
                Teknoloji ile hukuku birleştirerek, karmaşık prosedürleri basit,
                anlaşılır ve erişilebilir hale getirmek. Herkesin profesyonel
                hukuki belgelere kolayca ulaşabileceği bir platform sunmak.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Vision */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Vizyonumuz
              </h2>
              <div className="w-20 h-1 bg-primary-500 mx-auto mb-8"></div>
            </div>
            <div className="bg-white rounded-lg p-8 md:p-12 shadow-md">
              <p className="text-lg text-gray-700 leading-relaxed text-center">
                Türkiye'nin ve bölgenin en güvenilir, en kapsamlı hukuki belge
                otomasyon platformu olmak. Yapay zeka ve makine öğrenimi ile
                desteklenen, kullanıcı dostu arayüzü ile her ölçekteki
                kullanıcıya hizmet veren, sürekli gelişen ve yenilenen bir
                ekosistem yaratmak. Hukuki süreçlerde dijital dönüşümün öncüsü
                olmak.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Values */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Değerlerimiz
              </h2>
              <div className="w-20 h-1 bg-primary-500 mx-auto mb-8"></div>
              <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
                contractcode'u oluşturan temel değerler
              </p>
            </div>

            {/* Values Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {values.map((value, index) => (
                <Card key={index} className="p-8 text-center" hoverable>
                  {/* Icon */}
                  <div className="text-5xl mb-4">{value.icon}</div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {value.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Call to Action */}
      <section className="py-20 bg-primary-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Bizimle İletişime Geçin
            </h2>
            <p className="text-lg text-white/90 mb-8">
              Sorularınız için her zaman yanınızdayız
            </p>
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-white text-primary-600 font-semibold text-lg rounded-lg hover:bg-gray-50 transition-colors shadow-md"
            >
              İletişim
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

